import { EDIT_MY_PROFILE_SUCCESS } from '@redux/myProfile/types';
import {
  LOGIN_SUBMITTED,
  LOGIN_FAILED,
  AUTHENTICATION_REQUIRED,
  AUTHENTICATION_SUBMITTED,
  AUTHENTICATION_FAILED,
  LOGIN_REQUIRED,
  SESSION_ESTABLISHED,
  LOGOUT_SUCCESSFUL,
  SET_MFA_PREFERENCE_SUCCESSFUL,
  UPDATE_OWN_PROFILE_PICTURE,
} from './actions';

const initialState = {
  started: false,
  checkingSession: true,
  authenticated: false,
  user: {
    id: null,
    name: '',
    profile: {},
  },
  authentication: {},
  loading: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT_SUCCESSFUL:
    case LOGIN_REQUIRED:
      return {
        ...state,
        checkingSession: false,
        authenticated: false,
        loading: false,
        user: { id: null },
      };

    case AUTHENTICATION_SUBMITTED:
    case LOGIN_SUBMITTED:
      return {
        ...state,
        started: true,
        loading: true,
        error: false,
      };

    case AUTHENTICATION_FAILED:
    case LOGIN_FAILED:
      return {
        ...state,
        started: false,
        loading: false,
        error: true,
      };

    case AUTHENTICATION_REQUIRED:
      return {
        ...state,
        loading: false,
        authentication: {
          challengeType: action.payload.challengeType,
          codeDestination: action.payload.codeDestination,
        },
      };

    case SESSION_ESTABLISHED:
      return {
        ...state,
        started: false,
        checkingSession: false,
        authenticated: true,
        loading: false,
        user: {
          id: action.payload.id,
          name: action.payload.data.name,
          role: action.payload.data.role,
          email: action.payload.data.email,
          profile: action.payload.data.profile,
          preferredMfaSetting: action.payload.data.preferredMfaSetting,
        },
      };

    case SET_MFA_PREFERENCE_SUCCESSFUL:
      return {
        ...state,
        user: { ...state.user, preferredMfaSetting: action.payload.mfaPreference },
      };

    case EDIT_MY_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          preferredMfaSetting: action.payload.mfaPreference,
        },
      };

    case UPDATE_OWN_PROFILE_PICTURE:
      return {
        ...state,
        user: {
          ...state.user,
          profile: {
            ...state.user.profile,
            profilePictureImageId: action.payload.picture.profilePictureImageId,
            profilePictureUrl: action.payload.picture.profilePictureUrl,
          },
        },
      };
    default:
      return state;
  }
};

export const isLoading = state => state.login.loading;
export const hasError = state => state.login.error;

export const checkingSession = state => state.login.checkingSession;
export const hasValidSession = state => state.login.authenticated && state.login.user.id;
export const selectDashboardUserHospital = state => {
  if (state.login.user.profile.hospitalId) {
    return {
      hospitalId: state.login.user.profile.hospitalId,
      hospitalName: state.login.user.profile.hospitalName,
      hospitalSlug: state.login.user.profile.hospitalSlug,
    };
  }

  return {};
};
export const selectCurrentDashboardUser = state => state.login.user;
